import Store from "./store";

const BundleSelection = {
  handleBundleSubmit: function(){
    const bundleEl = document.querySelector('[data-bundle-section]');
    if (!bundleEl) return

    const button = bundleEl.querySelector('[data-bundle-add]');
    if (!button) return

    button.addEventListener('click', event => {
      event.preventDefault();
      Store.addProduct(bundleEl, bundleEl.parentElement)
    })
  },
  init: function(){
    BundleSelection.handleBundleSubmit();
  }
}

export default BundleSelection;
